const SESSION_KEY = 'bbx_survey_progress'

type SurveySessionSubmission = {
	questionId: string
	response: string[]
	optionId?: string[]
}

type SurveySession = {
	surveyId: number
	currentIndex: number
	submissions: SurveySessionSubmission[]
}

export function readSurveySession(surveyId: number | undefined): SurveySession | null {
	if (typeof surveyId !== 'number') return null
	try {
		const raw = sessionStorage.getItem(SESSION_KEY)
		if (!raw) return null
		const data: SurveySession = JSON.parse(raw)
		// Discard if the survey version has changed
		if (data.surveyId !== surveyId) return null
		return data
	} catch {
		return null
	}
}

export function writeSurveySession(data: SurveySession): void {
	try {
		sessionStorage.setItem(SESSION_KEY, JSON.stringify(data))
	} catch {
		// sessionStorage may be unavailable (private browsing, storage quota exceeded)
	}
}

export function clearSurveySession(): void {
	try {
		sessionStorage.removeItem(SESSION_KEY)
	} catch {
		// ignore
	}
}
